// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__lightBtn--ici5Z {\n  color: #00816B !important;\n  font-weight: 500;\n}\n.s-module__modalWrap--NCurX .ant-modal-close {\n  top: 24px !important;\n}\n", "",{"version":3,"sources":["webpack://./src/components/AddAndEditCalendarEvent/Modal/s.module.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,gBAAA;AADF;AAIA;EAGM,oBAAA;AAJN","sourcesContent":[".wrap {}\n\n.lightBtn {\n  color: #00816B !important;\n  font-weight: 500;\n}\n\n.modalWrap {\n  :global {\n    .ant-modal-close {\n      top: 24px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lightBtn": "s-module__lightBtn--ici5Z",
	"modalWrap": "s-module__modalWrap--NCurX"
};
export default ___CSS_LOADER_EXPORT___;
